import { Box, Breadcrumbs, Button, Card, CardContent, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import SimpleBackdrop from "../../components/SimpleBackdrop";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/th';
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import authStore from "../../stores/AuthStore";
import { useNavigate } from "react-router-dom";
import projectsStore from "../../stores/ProjectsStore";
import housesStore from "../../stores/HousesStore";
import sellStore from "../../stores/SellStore";
import PrintSells from "../../components/Report/Pdf/PrintSells";
import ExportFileSells from "../../components/Report/Excel/ExportFileSells";


const Sells: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dateTypes, setDateTypes] = useState('createDate');
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [dateTo, setDateTo] = useState<Dayjs | null>(dayjs());
  const [project, setProject] = useState('all');
  const [projectData, setProjectData] = useState([]);
  const [house, setHouse] = useState('all');
  const [houseData, setHouseData] = useState([]);
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [total, setTotal] = useState(0);
  const printRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });
  const exportRef = useRef(null);
  const permission: any = authStore.user?.roles.find((role: any) => role.menu.path === '/bookings');
  const [rows, setRows] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sortType, setSortType] = useState({ name: "วันที่บันทึก: ล่าสุด", variable: "createAtDESC", sortBy: "createAt", sortType: "DESC" });
  const sortOption = [
    { name: "วันที่บันทึก: ล่าสุด", variable: "createAtDESC", sortBy: "createAt", sortType: "DESC" },
    { name: "วันที่บันทึก: เก่าสุด", variable: "createAtASC", sortBy: "createAt", sortType: "ASC" },
    { name: "วันที่เอกสาร: ล่าสุด", variable: "docDateDESC", sortBy: "docDate", sortType: "DESC" },
    { name: "วันที่เอกสาร: เก่าสุด", variable: "docDateASC", sortBy: "docDate", sortType: "ASC" },
    { name: "วันที่แก้ไข: ล่าสุด", variable: "updateAtDESC", sortBy: "updateAt", sortType: "DESC" },
    { name: "วันที่แก้ไข: เก่าสุด", variable: "updateAtASC", sortBy: "updateAt", sortType: "ASC" },
  ];
  const [sortValue, setSortValue] = useState("createAtDESC");

  const handleChangeDateType = (event: ChangeEvent<HTMLInputElement>) => {
    setDateTypes((event.target as HTMLInputElement).value);
  };

  const handleChangeProject = (event: SelectChangeEvent) => {
    setProject((event.target as HTMLInputElement).value);
  };

  const handleChangeHouse = (event: SelectChangeEvent) => {
    setHouse((event.target as HTMLInputElement).value);
  };

  const handleSearch = (pageNumber?: string, limitNumber?: string, dateF?: Dayjs, dateT?: Dayjs, _sortType?: string, isRefresh = false) => {
    setIsLoading(true);
    setRows([]);
    const _page = parseInt(pageNumber || '0');
    const _limit = parseInt(limitNumber || '0');
    const data = {
      dateTypes: dateTypes,
      dateFrom: dateF ? dateF.format('YYYY-MM-DD') : dateFrom?.format('YYYY-MM-DD'),
      dateTo: dateT ? dateT.format('YYYY-MM-DD') : dateTo?.format('YYYY-MM-DD'),
      project: project,
      house: house,
      name: name,
      tel: tel,
      page: _page,
      limit: _limit,
      sortType: _sortType ? _sortType : sortType,
    };
    sellStore.getByCriteria(data).then((res) => {
      setRows(res?.data || []);
      setTotal(res?.total);
      if ((res?.total && res.total <= 10) || isRefresh === true) {
        setPage(0);
        setLimit(10);
      };
      const _sortType = localStorage.getItem('sortType');
      const _sortTypeConvert: any = _sortType ? JSON.parse(_sortType) : sortType;
      setSortType(_sortTypeConvert || sortType);
      setSortValue(_sortTypeConvert?.variable || 'createAtDESC');
      if (!_sortType) {
        localStorage.setItem('sortType', JSON.stringify(sortType));
      }
      setIsLoading(false);
    }).catch((err) => {
      console.error(err);
      setIsLoading(false);
    });
  };

  window.addEventListener("beforeunload", function (event) {
    localStorage.removeItem('dateFrom');
    localStorage.removeItem('dateTo');
    localStorage.removeItem('sortType');
    localStorage.removeItem('limit');
    localStorage.removeItem('page');
  });

  const handleChangeSort = (e: any) => {
    const findSortType: any = sortOption.find((item: any) => item.variable === e.target.value);
    localStorage.setItem('sortType', JSON.stringify(findSortType));
    setSortType(findSortType);
    setSortValue(e.target.value);
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      projectsStore.getAll(),
      housesStore.getAll()]).then(([projectData, houseData]) => {
        setProjectData(projectData);
        setHouseData(houseData);
        const _dateFrom = localStorage.getItem('dateFrom');
        const _dateTo = localStorage.getItem('dateTo');
        const dateF = dayjs(_dateFrom ? _dateFrom : dateFrom);
        const dateT = dayjs(_dateTo ? _dateTo : dateTo);
        const _limit = localStorage.getItem('limit');
        const _page = localStorage.getItem('page');
        setLimit(_limit ? parseInt(_limit) : limit);
        setPage(_page ? parseInt(_page) : page);
        setDateFrom(dateF);
        setDateTo(dateT);
        const _sortType: any = localStorage.getItem('sortType');
        const _sortTypeConvert: any = _sortType ? JSON.parse(_sortType) : sortType;
        setSortType(_sortTypeConvert || sortType);
        setSortValue(_sortTypeConvert?.variable || 'createAtDESC');
        if (!_sortType) {
          localStorage.setItem('sortType', JSON.stringify(sortType));
        }
        if (!_limit) {
          localStorage.setItem('limit', '10');
        }
        if (!_page) {
          localStorage.setItem('page', '0');
        }
        handleSearch(_page || undefined, _limit || undefined, dateF, dateT, _sortTypeConvert);
        setIsLoading(false);
      }).catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box component={'div'}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Typography>ขาย/จอง</Typography>
        <Typography variant="h6" color="text.primary">ขาย</Typography>
      </Breadcrumbs>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container spacing={2} alignItems={'end'}>
                <Grid item xs={12}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={dateTypes}
                      onChange={handleChangeDateType}
                    >
                      <FormControlLabel value="createDate" control={<Radio />} label="วันที่บันทึก" />
                      <FormControlLabel value="docDate" control={<Radio />} label="วันที่เอกสาร" />
                    </RadioGroup>
                  </FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'th'}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        label="ตั้งแต่วันที่"
                        value={dateFrom}
                        onChange={(newValue) => {
                          setDateFrom(newValue);
                          localStorage.setItem('dateFrom', newValue?.format('YYYY-MM-DD') || '');
                        }} />
                      <DatePicker
                        label="ถึงวันที่"
                        value={dateTo}
                        onChange={(newValue) => {
                          setDateTo(newValue);
                          localStorage.setItem('dateTo', newValue?.format('YYYY-MM-DD') || '');
                        }} />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <InputLabel>โครงการ</InputLabel>
                    <Select
                      value={project}
                      label="โครงการ"
                      onChange={handleChangeProject}
                    >
                      <MenuItem value={'all'}>ทั้งหมด</MenuItem>
                      {projectData && projectData?.length > 0 && projectData?.map((item: any) => (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <InputLabel>บ้าน</InputLabel>
                    <Select
                      value={house}
                      label="บ้าน"
                      onChange={handleChangeHouse}
                    >
                      <MenuItem value={'all'}>ทั้งหมด</MenuItem>
                      {houseData && houseData?.length > 0 && houseData?.map((item: any) => (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                </Grid>
                <Grid item xs={5}>
                  <TextField label="ชื่อลูกค้า" variant="outlined" fullWidth onChange={(event) => setName(event.target.value)} />
                </Grid>
                <Grid item xs={2.5}>
                  <TextField label="เบอร์โทรศัพท์" variant="outlined" fullWidth onChange={(event) => setTel(event.target.value)} />
                </Grid>
                <Grid item xs={2.5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">เรียงตาม
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sortValue}
                      label="sortType"
                      onChange={handleChangeSort}
                    >
                      {sortOption.map((option: any, index: number) => (
                        <MenuItem key={`sort-option-${index}`} value={option.variable}>{option.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} textAlign={'end'} pb={0.5}>
                  <Button variant="contained" onClick={() => handleSearch(undefined, undefined, undefined, undefined, undefined, true)} startIcon={<SearchIcon />}>ค้นหา</Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={9}>
                      <Typography>ทั้งหมด {total?.toLocaleString()} รายการ</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <DownloadTableExcel
                        filename={`sell-${dayjs(dateFrom).format('DD-MM-YYYY')} - ${dayjs(dateTo).format('DD-MM-YYYY')}`}
                        sheet={`booking-${dayjs(dateFrom).format('DD-MM-YYYY')} - ${dayjs(dateTo).format('DD-MM-YYYY')}`}
                        currentTableRef={exportRef.current}
                      >
                        <IconButton aria-label="download"  >
                          <DownloadIcon />
                        </IconButton>
                      </DownloadTableExcel>
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton aria-label="print" onClick={() => reactToPrintFn()}>
                        <PrintIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={1}>
                      {((permission && permission.create) || authStore.user?.isSuperAdmin) && <Button variant="contained" startIcon={<NoteAddIcon />} onClick={() => navigate('/sell-create')}>สร้าง</Button>}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>วันที่</TableCell>
                          <TableCell>ชื่อ-นามสกุล</TableCell>
                          <TableCell>ชื่อโครงการ</TableCell>
                          <TableCell>บ้าน</TableCell>
                          <TableCell width={100}>บันทึก</TableCell>
                          <TableCell width={100}>แก้ไข</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows && rows?.length > 0 && rows.map((row: any, index: number) => (
                          <TableRow
                            key={row.id + index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell>{dayjs(row.docDate).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{row?.booking?.customer?.firstname || ''} {row?.booking?.customer?.lastname || ''}</TableCell>
                            <TableCell>{row?.booking?.project?.name || ''}</TableCell>
                            <TableCell>{row?.booking?.house?.name || ''}</TableCell>
                            <TableCell>
                              {<b>{row.createBy?.name}</b>} {dayjs(row.createAt).format('DD/MM/YYYY HH:mm')}
                            </TableCell>
                            <TableCell>
                              {<b>{row.updateBy?.name}</b>} {row.updateAt ? dayjs(row.updateAt).format('DD/MM/YYYY HH:mm') : ''}
                            </TableCell>
                            <TableCell align="right">
                              <IconButton aria-label="edit" onClick={() => navigate(`/sell-edit/${row.id}`)}>
                                <KeyboardArrowRightIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                        {!rows && (
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell colSpan={10} align="center">ไม่พบข้อมูล</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box mt={3}>
                    <TablePagination
                      component="div"
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: -1 }]}
                      count={total}
                      onPageChange={(e, newPage) => {
                        setPage(newPage);
                        handleSearch(newPage.toString());
                        localStorage.setItem('page', newPage.toString());
                      }}
                      page={page}
                      rowsPerPage={limit ? limit : 10}
                      onRowsPerPageChange={(e: any) => {
                        setRows([]);
                        setLimit(e.target.value);
                        setPage(0);
                        handleSearch('0', e.target.value.toString());
                        localStorage.setItem('limit', e.target.value.toString());
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <SimpleBackdrop open={isLoading} />
      <Box sx={{ display: "none" }}>
        <PrintSells ref={printRef} title={`รายงานขาย ${dayjs(dateFrom).format('DD/MM/YYYY')} - ${dayjs(dateTo).format('DD/MM/YYYY')}`} date={`พิมพ์วันที่ ${dayjs().format('DD/MM/YYYY')}`} data={rows} />
      </Box>
      <Box sx={{ display: "none" }}>
        <ExportFileSells ref={exportRef} title={`รายงานขาย ${dayjs(dateFrom).format('DD/MM/YYYY')} - ${dayjs(dateTo).format('DD/MM/YYYY')}`} date={`พิมพ์วันที่ ${dayjs().format('DD/MM/YYYY')}`} data={rows} />
      </Box>
    </Box >
  );
};

export default Sells;
